import getAuthToken from './getAuthToken'
import getCurrentUser from './getCurrentUser'

const isAuthTokenValid = () => !!getAuthToken() && !!getCurrentUser()

export default isAuthTokenValid
